import { createTransport as q, ProviderDisconnectedError as h, hexToNumber as E, withRetry as v, withTimeout as T, ChainDisconnectedError as $ } from "viem";
function l(u, o = {}) {
  const { type: c } = u, { key: a = "connector", name: w = "Connector", retryDelay: y } = o;
  return (i) => {
    const { chain: e, connectors: t } = i, f = o.retryCount ?? i.retryCount;
    return q({
      key: a,
      name: w,
      request: async ({ method: C, params: r }) => {
        const d = t == null ? void 0 : t.getState().find((p) => p.type === c);
        if (!d)
          throw new h(
            new Error(
              `Could not find connector of type "${c}" in \`connectors\` passed to \`createConfig\`.`
            )
          );
        const n = await d.getProvider({
          chainId: e == null ? void 0 : e.id
        });
        if (!n)
          throw new h(
            new Error("Provider is disconnected.")
          );
        const s = E(
          await v(
            () => T(() => n.request({ method: "eth_chainId" }), {
              timeout: 1e3
            })
          )
        );
        if (e && s !== e.id)
          throw new $(
            new Error(
              `The current chain of the connector (id: ${s}) does not match the target chain for the request (id: ${e.id} – ${e.name}).`
            )
          );
        r || (r = []);
        const m = { method: C, params: r };
        return n.request(m);
      },
      retryCount: f,
      retryDelay: y,
      type: "connector"
    });
  };
}
export {
  l as unstableConnector
};
//# sourceMappingURL=unstableConnector.js.map
